import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/reasons/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddContactModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function CustomerList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Payment Methods" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Reasons</h5>
      </div>

      <CrudProvider>
        <PaymentMethodTable />
      </CrudProvider>
    </>
  )
}

function PaymentMethodTable() {
  const { data: response, isLoading } = useCustomQuery(
    ["reasons"],
    "settings?filter[key]=reason"
  )
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Reasons"
        columns={columns}
        data={response?.data.data}
        isLoading={isLoading}
        apiPath="settings"
      />

      {openDialog ? <AddContactModal /> : null}
    </>
  )
}
